// Nhận diện người đang đăng nhập để bật/tắt chức năng cho một nhóm user cụ thể.
// Tách khỏi component để test được và để chỗ khác dùng lại.
import jwt_decode from "jwt-decode";
import { AUTH_TOKEN, USER_INFO } from "store/auth/login/actionTypes";

// Token của hệ thống đặt email người đăng nhập ở clientInfo.email
// (vd "admin@pnj.com.vn"). userInfo.userName và sub chỉ là UUID nên không dùng.
// Vẫn dò thêm vài field email khác phòng khi token đổi dạng.
const USER_NAME_PATHS = [
  ["clientInfo", "email"],
  ["clientInfo", "contactEmail"],
  ["email"],
  ["preferred_username"],
];

const readPath = (data, path) =>
  path.reduce((result, step) => (result ? result[step] : undefined), data);

/** "VI.NTT@lcs.com.vn " -> "vi.ntt": bỏ khoảng trắng, thường hóa, bỏ phần @ */
export const normalizeUserName = value => {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim().toLowerCase().split("@")[0];
};

/**
 * Mọi tên có thể dùng để nhận ra người đang đăng nhập.
 * @param {object | null} tokenInfo payload JWT đã giải mã
 * @param {object | null} userInfo object lưu trong localStorage USER_INFO
 * @returns {string[]} đã chuẩn hóa, không trùng, không rỗng
 */
export const collectUserNames = (tokenInfo, userInfo) => {
  const values = USER_NAME_PATHS.map(path => readPath(tokenInfo, path)).concat([
    // Email đã gõ lúc đăng nhập, lưu kèm trong localStorage
    userInfo?.userName,
  ]);

  return [...new Set(values.map(normalizeUserName).filter(Boolean))];
};

/**
 * Người đang đăng nhập có nằm trong danh sách được phép không.
 * Danh sách rỗng = không ai được phép (chặn mặc định, tránh lỡ mở cho tất cả).
 * @param {string[]} userNames tên của người đang đăng nhập
 * @param {string[]} allowedUserNames danh sách cho phép
 */
export const isAllowedUser = (userNames, allowedUserNames) => {
  const allowed = (allowedUserNames || [])
    .map(normalizeUserName)
    .filter(Boolean);

  if (allowed.length === 0) {
    return false;
  }

  return (userNames || []).some(name => allowed.includes(name));
};

/** Đọc thẳng từ localStorage; hỏng dữ liệu thì coi như không nhận ra ai */
export const getCurrentUserNames = () => {
  let tokenInfo = null;
  let userInfo = null;

  try {
    const token = localStorage.getItem(AUTH_TOKEN);
    tokenInfo = token ? jwt_decode(token) : null;
  } catch (error) {
    tokenInfo = null;
  }

  try {
    userInfo = JSON.parse(localStorage.getItem(USER_INFO) || "null");
  } catch (error) {
    userInfo = null;
  }

  return collectUserNames(tokenInfo, userInfo);
};
